<template>
  <v-navigation-drawer
      :value="value"
      v-on:input="$emit('input', $event)"
      fixed
      temporary
      style="height:100vh !important;"
      right  >
<!--  <v-navigation-drawer-->
<!--      v-model="drawer"-->
<!--      class="nav-draw"-->
<!--      fixed-->
<!--      right-->
<!--      style="height:100vh !important;"-->
<!--      temporary>-->
    <div class="row py-3 text-center my-2 mb-5 pb-5 ">
      <div v-if="logo !== null" class="col-12 px-5 ">
        <img
            :src="$replaceHttps(logo)" alt="logo" height="100"/>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text light-gray-top-border mt-5"
               @click="navigateTo('Profile')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-user-circle"></i>
            </div>
            <div class="col-9 text-right">
              <label>پروفایل</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('Membership')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-user-tag"></i>
            </div>
            <div class="col-9 text-right ">
              <label>عضویت</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('KnowledgeBase')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-info-circle"></i>
            </div>
            <div class="col-9 text-right ">
              <label>پایگاه دانش</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('ClassScores')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-file-alt"></i>
            </div>
            <div class="col-9 text-right ">
              <label>نمرات کلاسی</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text"
               @click="navigateTo('SpecialReports')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-file-chart-line"></i>
            </div>
            <div class="col-9 text-right ">
              <label>گزارشات ویژه</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text"
               @click="navigateTo('WeeklySchedule')">
            <div class="col-3 py-0 text-center">
              <i class="fal fa-table"></i>
            </div>
            <div class="col-9 text-right ">
              <label>برنامه هفتگی</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('Performance')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-pen-square"></i>
            </div>
            <div class="col-9 text-right ">
              <label>ثبت عملکرد دانش آموز</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('BMI')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-weight"></i>
            </div>
            <div class="col-9 text-right ">
              <label>ثبت BMI (شاخص توده بدنی)</label>
            </div>

          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('SleepQuality')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-alarm-clock"></i>
            </div>
            <div class="col-9 text-right ">
              <label>ثبت ساعت خواب</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('Points')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-star"></i>
            </div>
            <div class="col-9 text-right ">
              <label>امتیازات</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('Attendance')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-clipboard-list-check"></i>
            </div>
            <div class="col-9 text-right ">
              <label>حضور و غیاب</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center " @click="navigateTo('OnlineExam')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-file-edit"></i>
            </div>
            <div class="col-9 text-right ">
              <label>آزمون آنلاین</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center " @click="navigateTo('SurveyList')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-vote-yea"></i>
            </div>
            <div class="col-9 text-right ">
              <label>نظرسنجی</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('Messages')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-comment-dots"></i>
            </div>
            <div class="col-9 text-right ">
              <label>پیام ها</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('ClassReport')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-file-alt"></i>
            </div>
            <div class="col-9 text-right ">
              <label>گزارش کلاسی</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('AboutApp')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-info-square"></i>
            </div>
            <div class="col-9 text-right ">
              <label>درباره اپ</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('ConnectUs')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-phone-square"></i>
            </div>
            <div class="col-9 text-right ">
              <label>تماس با ما</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('AboutSchool')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-chalkboard-teacher"></i>
            </div>
            <div class="col-9 text-right ">
              <label>درباره مدرسه</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="navigateTo('SocialMedia')">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-hashtag"></i>
            </div>
            <div class="col-9 text-right ">
              <label>شبکه اجتماعی</label>
            </div>
          </div>
          <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="signOut">
            <div class="col-3 py-0 text-center">
              <i class="fas fa-sign-out-alt"></i>
            </div>
            <div class="col-9 text-right ">
              <label>خروج</label>
            </div>
          </div>
          <!--    <div class="row drawerItemsWrapper px-3 align-items-center primary-text" @click="signOut">
                <div class="col-3 py-0 text-center">
                  <i class="fal fa-sign-out"></i>
                </div>
                <div class="col-9 text-right">
                  <label>خروج</label>
                </div>
              </div>-->
        </div>
      </div>
    </div>

  </v-navigation-drawer>
</template>

<script>
export default {
  name: "SidebarNavigation",
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    logo: null

  }),
  mounted() {
    this.logo = this.$getSchoolInfo().schoolLogo
  },
  methods: {
    navigateTo(path) {
      if (this.$router.currentRoute.fullPath.indexOf(path) === -1) {
        this.$router.push({path: path});
      }
    },
    signOut() {
      this.$setUserData('', '', '', '', '', '', '','','','')
      this.$setUserLogo('')
      this.$setSchoolInfo('', '', '')
      this.$setModalID('')
      this.$router.replace({path: 'Login'})
    }

  }
}
</script>

<style scoped>

</style>
